import React from 'react';
import { Link } from 'react-router-dom';

const CoreOfferings = () => {
  return (
    <div className="offerings-section">
      <h2>Our Core Offerings</h2> 
      <div className="cards-container">
        <div className="card">
        <Link to="/MutualFundPage">
          <h3>
            <Link to="/MutualFundPage" className="text-decoration-none text-dark">📈 Mutual Fund</Link>
          </h3>
          <p>
            Mutual funds offer a managed route to grow wealth through equities, debt, or hybrid schemes. Start SIPs or lumpsum easily with tailored recommendations to suit your goals.
          </p>
          </Link>
        </div>

        <div className="card">
           <Link to="/LoanAgainstSecuritiesPage">
          <h3>
            <Link to="/LoanAgainstSecuritiesPage" className="text-decoration-none text-dark">💰 Loan Against Securities</Link>
          </h3>
          <p>
            Get funds instantly without selling your investments. Pledge your mutual funds or shares and enjoy flexible, quick processing with minimal documentation.
          </p>
          </Link>
        </div>

        <div className="card">
        <Link to="/BondPage">
          <h3>
            <Link to="/BondPage" className="text-decoration-none text-dark">💳 Bond</Link>
          </h3>
          <p>
            Bonds provide steady returns with low risk. Choose from government or corporate options to ensure capital safety and predictable income.
          </p>
          </Link>
        </div>

        <div className="card">
          <Link to="/AIFPage">
          <h3>
            <Link to="/AIFPage" className="text-decoration-none text-dark">📊 AIF</Link>
          </h3>
          <p>
            AIFs offer unique opportunities like hedge funds and private equity for seasoned investors. Ideal for high returns with managed risk and expert insights.
          </p>
          </Link>
        </div>

        <div className="card">
          <Link to="/ResearchAnalystPage">
          <h3>
            <Link to="/ResearchAnalystPage" className="text-decoration-none text-dark">🧠 Research Analyst</Link>
          </h3>
          <p>
            Make smart choices backed by data. Our analysts offer market insights, sector trends, and portfolio suggestions tailored to your strategy.
          </p>
          </Link>
        </div>

        <div className="card">
          <Link to="/GlobalAccessPage">
          <h3>
            <Link to="/GlobalAccessPage" className="text-decoration-none text-dark">🌐 Global Access</Link>
          </h3>
          <p>
            Invest globally with ease. Tap into international funds and diversify beyond domestic markets with expert-curated options and support.
          </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CoreOfferings;
